

























































































/* eslint-disable @typescript-eslint/camelcase */

import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm'
import { Component, Vue } from 'vue-property-decorator'
import InputNumber from '@/components/Controls/InputNumber.vue'
import InputTextarea from '@/components/Controls/InputTextarea.vue'
import Calendar from '@/components/Controls/Calendar.vue'
import { componentsImports } from '../FormFields/index'

@Component({
  components: {
    ...componentsImports(),
    ValidationProvider,
    InputNumber,
    InputTextarea,
    Calendar
  }
})
export default class ResidentialBoardingHouseMultiTenant extends Vue {
  formData () {
    return {
      GeneralCondition: this.generalCondition,
      FloorConstruction: this.floorConstruction,
      WallConstruction: this.wallConstruction,
      RoofConstruction: this.roofConstruction,
      ApproximateBuildYear: this.approximateBuildYear,
      EstimatedValue: this.estimatedValue,
      CurrentRental: this.currentRental,
      NumberOfBedrooms: this.bedrooms,
      NumberOfBathrooms: this.bathrooms,
      CarParks: this.carParks,
      FloorArea: this.floorArea,
      FloorLevel: this.floorLevel,
      Other: this.other,
      PropertyFeatures: this.propertyFeatures,

      CommercialOfficeArea: this.commercialOfficeArea,
      RetailShowroomArea: this.retailShowroomArea,
      IndustrialWarehouseWorkshopArea: this.industrialWarehouseWorkshopArea,
      CommercialStaffAmenitiesArea: this.commercialStaffAmenitiesArea,
      ExternalArea: this.externalArea,

      ExternalAreaDescription: this.externalAreaDescription,
      AdditionalPropertyDetails: this.additionalPropertyDetails
    }
  }

  loadData (data: any) {
    this.generalCondition = data.GeneralCondition
    this.floorConstruction = data.FloorConstruction
    this.wallConstruction = data.WallConstruction
    this.roofConstruction = data.RoofConstruction
    this.approximateBuildYear = data.ApproximateBuildYear
    this.estimatedValue = data.EstimatedValue
    this.currentRental = data.CurrentRental
    this.bedrooms = data.NumberOfBedrooms
    this.bathrooms = data.NumberOfBathrooms
    this.carParks = data.CarParks
    this.floorArea = data.FloorArea
    this.floorLevel = data.FloorLevel
    this.other = data.Other
    this.propertyFeatures = data.PropertyFeatures

    this.commercialOfficeArea = data.CommercialOfficeArea
    this.retailShowroomArea = data.RetailShowroomArea
    this.industrialWarehouseWorkshopArea = data.IndustrialWarehouseWorkshopArea
    this.commercialStaffAmenitiesArea = data.CommercialStaffAmenitiesArea
    this.externalArea = data.ExternalArea

    this.externalAreaDescription = data.ExternalAreaDescription
    this.additionalPropertyDetails = data.AdditionalPropertyDetails
  }

  propertyType () {
    return 'ResidentialApartment'
  }

  generalCondition = null
  approximateBuildYear = null
  floorArea = null
  carParks = null
  floorConstruction = null
  wallConstruction = null
  roofConstruction = null
  estimatedValue = null
  currentRental = null
  bedrooms = null
  bathrooms = null
  floorLevel = null
  other = null
  propertyFeatures: string[] = []

  commercialOfficeArea: any = null
  retailShowroomArea: any = null
  industrialWarehouseWorkshopArea: any = null
  commercialStaffAmenitiesArea: any = null
  externalArea: any = null

  externalAreaDescription: any = null
  additionalPropertyDetails: any = null
}
